import { TagPicker as RsuiteTagPicker } from "rsuite";

import "./tagPicker.scss";
import RenderTags from "../renderTags/RenderTags";

const TagPicker = (props) => {
  const { labelKey, valueKey } = props || {};
  const renderValue = RenderTags({ labelKey, valueKey });
  return <RsuiteTagPicker renderValue={renderValue} {...props} />;
};

export default TagPicker;
